import { SELLER_DATA_VOID } from "@shared-logic/subjects"
import { Exchange, OrderExchange } from "@shared-logic/orders"
import { OBJECT_ID_VOID } from "./options"
import { PLACE_OF_ORIGIN_VOID } from "@shared-logic/locations"
import { WAY_PAY_VOID } from "@shared-logic/payments"
import { orderInitialState } from "@shared-logic/orders"

export const exchangeTags = {
    exchange: 'exchange',
    status: 'status',
    buyer: 'buyer',
    agreedDiscount: 'agreedDiscount',
    priceDiscount: 'priceDiscount',
    percentageB: 'percentageB',
    amountB: 'amountB',
    motherContract: 'motherContract',
}

export const exchangeInitialState: Exchange = {
    status: -1,
    buyer: SELLER_DATA_VOID,
    tons: -1,
    howSell: -1,
    purchaseMethod: 0   ,
    placeOfOrigin: PLACE_OF_ORIGIN_VOID,
    price: -1,
    typeCoin: '--',
    codeWayPay: -1,
    daysWayPay: -1,
    contractNumber: -1,
    agreedDiscount: -1,
    priceDiscount: -1,
    wayPay: WAY_PAY_VOID,
    isFixedPrice: false,
    amountB: -1,
    percentageB: -1,
    isMotherCounterpart: -1,
    idMother: OBJECT_ID_VOID,
}

export const orderExchangeInitialState: OrderExchange = {
    ...orderInitialState,
    exchange: exchangeInitialState
}

export const EXCHANGE_STATUS_CONST = {
    INCOMPLETO: 1,
    VERIFICAR: 2,
    COMPLETA: 3,
}